import { Component, OnInit } from '@angular/core';
import { ConstantePage } from 'src/app/constants/constante-page';
import { TagWaService } from 'src/app/services/tag-wa.service';

@Component({
  selector: 'ccd-page-erreur-technique',
  templateUrl: './ccd-page-erreur-technique.component.html'
})
export class CcdPageErreurTechniqueComponent implements OnInit {

  pageName = ConstantePage.STATS_PAGE_INCIDENT;
  chapter3Page = ConstantePage.STATS_CHAPTER3_PAGE_INCIDENT;

  constructor(
    private tagWaService: TagWaService
  ) { }

  ngOnInit(): void {
    // On tague la page pour le WA
    this.tagWaService.tagPage(this.pageName, this.chapter3Page);
  }

}
